import {Stack, Label, Text} from '@primer/react-brand'
import {formatStringToKebabCase} from '../../lib/utils'
import React from 'react'
import {t} from '@github-ui/swp-core/lib/utils/localization'

export function Topics({topics, baseUrl, filterName}: {topics: string[]; baseUrl?: string; filterName?: string}) {
  return (
    <Stack direction="horizontal" padding="none" flexWrap="wrap">
      <Text>{t('Tags')}</Text>
      {topics?.map(topic => (
        <React.Fragment key={topic}>
          {baseUrl && filterName ? (
            <a href={`${baseUrl}?${filterName}=${formatStringToKebabCase(topic)}`}>
              <Label>{t(topic)}</Label>
            </a>
          ) : (
            <Label>{t(topic)}</Label>
          )}
        </React.Fragment>
      ))}
    </Stack>
  )
}

try{ Topics.displayName ||= 'Topics' } catch {}